// ============================================
// src/components/layout/Hero.tsx (SIMPLIFICADO)
// ============================================
"use client";
import HeroHeader from '../home/HeroHeader';
import VideoShowcase from '../home/VideoShowcase';

export default function Hero() {
  return (
    <>
      {/* HeroHeader que incluye Hero + AboutSection con la imagen de fondo */}
      <HeroHeader />
      
      {/* VideoShowcase separado (sin cambios) */}
      <VideoShowcase />
    </>
  );
}